import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'MatchItems'
})
export class ItemMatchingPipe implements PipeTransform {
  transform(items: any[], field: string, elements: any[]): any[] {
    if(!items) return [];
    if(!field) return items;
    const reducedElements = Object.keys(elements).reduce((accumulator, item)=>{
      if(elements[item] == true){
        return [...accumulator, item];
      }
      return accumulator;
    }, []);
    if(reducedElements.length == 0){
      return items;
    }
    return items.filter( it => {
      return reducedElements.indexOf(it[field]) > -1;
    });
   }
}
// function intersect(a, b) {
//   var setB = new Set(b);
//   return [Array.from(new Set(a))].filter(x => setB.has(x));
// }



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/item-matching.pipe.ts